import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { DataList } from '../data-list/data-list.class';
import { EnumDataListColumnType, IDataListColumn, IDataListOrderBy, DataListComponent } from '../data-list/data-list.component';
import { Subscription } from 'rxjs';
import { IUser } from '@simplyfly/shared';
import { AppDataService } from 'src/app/services/data/app-data.service';
import { IFlightBrief } from '@simplyfly/shared';
import { FlightBriefService } from 'src/app/services/flight-briefs/flight-briefs.service';
import { getLanguageLabel } from 'src/app/enums/language.helpers';
import { UserService } from 'src/app/services/user/user.service';
import { EnumAcl } from '@simplyfly/shared';
import { AclService } from 'src/app/services/acl.service';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-flight-briefs-list-for-enquiry',
    templateUrl: './flight-briefs-list-for-enquiry.component.html',
    styleUrls: ['./flight-briefs-list-for-enquiry.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DataListComponent]
})
export class FlightBriefsListForEnquiryComponent
  extends DataList<IFlightBrief>
  implements OnInit, OnChanges, OnDestroy
{
  @Input() enquiryId: string | null = null;

  faPlus = faPlus;

  EnumAcl = EnumAcl;

  usersObj: { [id: string]: IUser } = {};

  currentPagination = 'enquiry-flight-briefs-list';
  columns: IDataListColumn[] = [
    {
      title: this.translateService.instant('GENERAL.VERSION'),
      field: 'title',
      notSortable: true
    },
    {
      title: this.translateService.instant('GENERAL.LANGUAGE'),
      field: 'language',
      notSortable: true,
      type: EnumDataListColumnType.function,
      resolve: (item: IFlightBrief): string => {
        return getLanguageLabel(item.language);
      }
    },
    {
      title: this.translateService.instant('GENERAL.DATE_CREATED'),
      field: 'created',
      notSortable: true,
      type: EnumDataListColumnType.date
    },
    {
      title: this.translateService.instant('GENERAL.CREATED_BY'),
      field: 'createdBy',
      notSortable: true,
      type: EnumDataListColumnType.function,
      resolve: (item: IFlightBrief): string => {
        return item.createdBy && this.usersObj[item.createdBy]
          ? this.usersObj[item.createdBy].initials
          : '';
      }
    },
    {
      title: this.translateService.instant('GENERAL.DATE_SENT'),
      field: 'sentDate',
      notSortable: true,
      type: EnumDataListColumnType.date
    },
    {
      title: this.translateService.instant('GENERAL.SENT_BY'),
      field: 'sentBy',
      notSortable: true,
      type: EnumDataListColumnType.function,
      resolve: (item: IFlightBrief): string => {
        return item.sentBy && this.usersObj[item.sentBy] ? this.usersObj[item.sentBy].initials : '';
      }
    }
  ];

  orderBy: IDataListOrderBy | null = { field: 'created', direction: 'desc' };

  isLogged = false;

  private subscriptions = new Subscription();

  constructor(
    private authService: AuthService,
    private flightBriefService: FlightBriefService,
    private appDataService: AppDataService,
    private userService: UserService,
    private aclService: AclService,
    private translateService: TranslateService
  ) {
    super();

    this.setDataService(this.flightBriefService);
  }

  ngOnInit(): void {
    this.authService.isLoggedObservable.subscribe(
      (isLogged: boolean) => (this.isLogged = isLogged)
    );

    this.updatedEnquiryId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.enquiryId && !changes.enquiryId.isFirstChange()) {
      this.updatedEnquiryId();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  updatedEnquiryId(): void {
    if (this.isLogged) {
      if (this.enquiryId) {
        this.conditions = [
          {
            field: 'enquiryId',
            operator: '==',
            value: this.enquiryId
          }
        ];

        this.resetAndLoad();
      }

      this.loadUsers();
    } else {
      setTimeout(() => {
        this.updatedEnquiryId();
      }, 500);
    }
  }

  loadUsers(): void {
    this.subscriptions.add(
      this.userService.getAll().subscribe((users: IUser[]) => {
        for (const user of users) {
          this.usersObj[user.id] = user;
        }
      })
    );
  }

  hasAclAccess(id: EnumAcl): boolean {
    return this.aclService.hasAclAccess(id);
  }
}
